module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/hlukovaMapa@2x-110d7b4c886059e7ebb54e57edb744e7.png";